// React Query keys, in one place so invalidations match the hooks that read them.
//   ["job", id]                        useJob             GET /v1/jobs/{id}
//   ["jobs", limit]                    useJobs            GET /v1/jobs?limit=
//   ["nodes"]                          useNodes           GET /v1/nodes
//   ["artifacts", id]                  useArtifacts       GET /v1/jobs/{id}/artifacts
//   ["artifact-json", id, sha]         useArtifactJson    GET /v1/jobs/{id}/artifacts/{sha} (same-origin)
//   ["config"]                         useConfig          GET /v1/config
//   ["me"]                             useMe              GET /v1/auth/me
//   ["bulk-usage"]                     useBulkUsage       GET /v1/bulk/usage
//   ["intel", sha256]                  useThirdParty      GET /v1/samples/{sha256}/intel
export const keys = {
  job: (id: string) => ["job", id] as const,
  jobs: (limit: number) => ["jobs", limit] as const,
  allJobs: ["jobs"] as const,
  nodes: ["nodes"] as const,
  artifacts: (id: string) => ["artifacts", id] as const,
  artifactJson: (id: string, sha: string) => ["artifact-json", id, sha] as const,
  config: ["config"] as const,
  me: ["me"] as const,
  bulkUsage: ["bulk-usage"] as const,
  intel: (sha: string) => ["intel", sha] as const,
};
